// 【公共组件】本地/云端流程切换
export default {
    'toggleProcess.tips1': '当前检测到无网状态，请联网后再操作！',
    'toggleProcess.tips2': '没有获取到本地的域名，请确认当前连接的wifi是配网的wifi。' ,
    'toggleProcess.tips3': '请问确认要切换版本吗？请注意不同的版本展示的页面会不相同。' 
}
 